import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Linkedin } from 'lucide-react';
import { siteConfig } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/5 py-12">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <img
              src={`${process.env.PUBLIC_URL}/assets/logo-comprecliente.png`}
              alt="CompreCliente"
              className="h-10 w-auto mb-4 object-contain"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Assessoria de marketing que restaurantes e negócios locais escolhem quando querem resultados reais e mensuráveis.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Seja um Parceiro</h3>
            <ul className="space-y-2">
              <li>
                <a href={`https://wa.me/${siteConfig.whatsapp}?text=Quero%20ser%20parceiro%20Visual`} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Visual
                </a>
              </li>
              <li>
                <a href={`https://wa.me/${siteConfig.whatsapp}?text=Quero%20ser%20parceiro%20Designer`} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Designer
                </a>
              </li>
              <li>
                <a href={`https://wa.me/${siteConfig.whatsapp}?text=Quero%20ser%20parceiro%20Influenciador`} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Influenciador
                </a>
              </li>
              <li>
                <a href={`https://wa.me/${siteConfig.whatsapp}?text=Quero%20ser%20parceiro%20Programador`} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Programador
                </a>
              </li>
              <li>
                <a href={`https://wa.me/${siteConfig.whatsapp}?text=Quero%20ser%20parceiro%20Gestor%20SEO`} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Gestor SEO Google
                </a>
              </li>
              <li>
                <a href={`https://wa.me/${siteConfig.whatsapp}?text=Quero%20ser%20parceiro%20Gestor%20de%20Tráfego%20Meta%20Ads`} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Gestor de Tráfego Meta Ads
                </a>
              </li>
              <li>
                <a href={`https://wa.me/${siteConfig.whatsapp}?text=Quero%20ser%20parceiro%20Gestor%20de%20Tráfego%20Google%20Ads`} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Gestor de Tráfego Google Ads
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Serviços</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/social-media-vitrine" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Social Media Vitrine
                </Link>
              </li>
              <li>
                <Link to="/engenharia-cardapio" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Engenharia de Cardápio
                </Link>
              </li>
              <li>
                <Link to="/edicao" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Edição de Vídeo/Imagem
                </Link>
              </li>
              <li>
                <Link to="/copy-roteiros" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Copy + Roteiros
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contato</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href={`https://wa.me/${siteConfig.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  WhatsApp
                </a>
              </li>
              <li className="text-gray-400 text-sm">contato@comprecliente.com.br</li>
              <li className="text-gray-400 text-sm">CNPJ: 40.025.171/0001-90</li>
            </ul>
            <div className="flex space-x-4 mt-6">
              <a
                href="https://www.instagram.com/assessoriacomprecliente"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.facebook.com/assessoriacomprecliente"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0">
            <p className="text-gray-500 text-xs">
              © {currentYear} CompreCliente. Todos os direitos reservados.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-500 hover:text-gray-400 text-xs transition-colors">
                Política de Privacidade
              </a>
              <a href="#" className="text-gray-500 hover:text-gray-400 text-xs transition-colors">
                Termos de Uso
              </a>
              <a href="#" className="text-gray-500 hover:text-gray-400 text-xs transition-colors">
                LGPD
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
